/**
 * <TutorApplicationStepDonePage> — une étape de la candidature est finie (page).
 *
 * L'ancien `CongratsScreen` au type `APPLICATION_STEP_CONGRATS` (`ApplicationStepCongrats`) :
 * « ÉTAPE TERMINÉE ! » sur une coche animée, le son de fin, puis le champion de l'étape qui dit la
 * suite (« Tu vas pouvoir passer à l'entretien de Zoé »), et « CONTINUER ». Le tuteur reçoit
 * l'arène en sourdine (cadrage du 28/10) : pas de confetti, la coche verte de `<FlowOutcome>`.
 *
 * Comme l'intro (`<TutorApplicationChampionTemplate>`), le champion en pied, et il danse
 * (`pose="dancing"`, la danse de fin d'activité de l'élève ; content et fixe en mouvement réduit) ; sa
 * phrase dans sa bulle.
 *
 * Contrôlée : le champion et sa phrase arrivent en props ; « Continuer » remonte.
 */
import React from "react"

import { type ChampionName } from "../../atoms/Avatar/ChampionAvatar"
import { Button } from "../../atoms/Buttons/Button"
import { FlowOutcome } from "../../molecules/FlowOutcome"
import { TutorApplicationChampionTemplate } from "../../templates/TutorApplicationChampionTemplate"

const TUTOR_APPLICATION_STEP_DONE_TEXTS = { title: "Étape terminée !", next: "Continuer" }

const FIGURE_HEIGHT = { narrow: 240, wide: 300 }

export type TutorApplicationStepDonePageProps = {
    champion: ChampionName
    /** Ce qu'il dit de la suite. */
    text: string
    onNext: () => void
    testID?: string
}

export function TutorApplicationStepDonePage(props: TutorApplicationStepDonePageProps) {
    const { champion, text, onNext, testID } = props

    return (
        <TutorApplicationChampionTemplate
            testID={testID}
            champion={champion}
            pose="dancing"
            figureHeight={FIGURE_HEIGHT}
            above={
                <FlowOutcome iconName="check" tone="success" message={TUTOR_APPLICATION_STEP_DONE_TEXTS.title} center />
            }
            text={text}
            action={<Button label={TUTOR_APPLICATION_STEP_DONE_TEXTS.next} fullWidth onPress={onNext} />}
        />
    )
}
